'use client';

function getVariantClassName(_ref) {
  var options = _ref.options,
    classes = _ref.classes,
    selector = _ref.selector,
    unstyled = _ref.unstyled;
  return options !== null && options !== void 0 && options.variant && !unstyled ? classes["".concat(selector, "--").concat(options.variant)] : void 0;
}
export { getVariantClassName };